import { storeCTEvent, storeEvent }           from "_analytics/index";
import Toast                                  from "_common/toast";
import { clearUserData, storeUserDataCookie } from "_common/utils/user";
import { createAuthData }                     from "_services/api/auth";
import {
	loginApi, loginWithGoogleApi, logoutApi
} from "_services/api/auth";
import { getMyUserProfile } from "_services/api/user";

const userProfileParams = {
	follow            : true,
	isFollowing       : true,
	country           : true,
	stats             : true,
	block             : true,
	gems              : true,
	teams             : false,
	sports            : false,
	pendingRewards    : false,
	access            : true,
	types             : true,
	followingGames    : true,
	onboarding        : true,
	communityTeamUser : true
};

export const getOwnProfile = async ( ) => {
	const userProfileData = await getMyUserProfile ( userProfileParams );

	return userProfileData;

};

export const loginUser = async data => {
	const response        = await loginApi ( data );
	const userProfileData = await getOwnProfile ();

	const eventAction = response.isNew ? "Sign_Up" : "Log_In";
	const eventLabel  = response.isNew ? "Header_SignUp" : "Header_LogIn";

	storeEvent ( "Authentication", eventAction, eventLabel );
	storeCTEvent ( {
		eventName : "user_signed_in",
		campaign  : "organic",
		is_new    : response.isNew ? 1 : 0,
		OS        : "Web"
	} );

	storeUserDataCookie ( response );

	return { userProfileData };
};

export const loginUserWithGoogle = async data => {
	const response        = await loginWithGoogleApi ( data );
	const userProfileData = await getOwnProfile ();

	storeUserDataCookie ( response );

	return { userProfileData };
};

export const logoutUser = async data => {
	try {
		if ( !data?.forceLogout ) {
			await logoutApi ();
			storeEvent ( "Authentication", "Log_out", "Header_Logout" );
			if ( !data?.deleteAccount ) {
				Toast.info ( "Successfully logged out." );
			}
		}
		clearUserData ();
		await createAuthData ();

	} catch ( error ) {
		Toast.error ( error.displayMsg );
	}
};
